/*
 * @Author: Gang Jiang 
 * @Date: 2024-11-07 15:39:13 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-11-07 22:05:58
 */
import client from './client';

export default {
  getList: (data) => {
    return client.get('link/analytics/console/list?' + Object.keys(data).map(key => {
      return `${key}=${data[key]}`
    }).join('&')).then(res => res.data);
  },
}